import { render, staticRenderFns } from "./Photo.vue?vue&type=template&id=b12f1042&scoped=true&"
import script from "./Photo.vue?vue&type=script&lang=ts&"
export * from "./Photo.vue?vue&type=script&lang=ts&"
import style0 from "./Photo.vue?vue&type=style&index=0&id=b12f1042&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12f1042",
  null
  
)

export default component.exports